import { Status, Spinner } from '@doxyme/ui/components/foundations';
import { Icon } from '@doxyme/icons';
import { type Specs } from '@doxyme/extensions-common';

import type { JSX } from 'react';

type NotificationIcon = Specs.Notification.NotificationIcon;
type NotificationPayloadBase = Specs.Notification.NotificationPayloadBase;

const notificationIconMap: Record<NotificationIcon, JSX.Element> = {
  success: <Status statusLevel='success' />,
  info: <Status statusLevel='info' />,
  warning: <Status statusLevel='warning' />,
  error: <Status statusLevel='error' />,
  loading: <Spinner size={18} disableShrink mode={'green'} />,
  transcription: <Icon.Transcript size={24} type='stroke' />,
  scribe: <Icon.Scribe size={24} type='stroke' />,
  medal: <Icon.Medal size={24} type='stroke' />,
  trophy: <Icon.Trophy size={24} type='stroke' />,
  cross: <Icon.Cross size={24} type='stroke' />,
  // Add more mappings as needed
};

export const getNotificationIcon = (
  payload: NotificationPayloadBase,
): JSX.Element | undefined => {
  const icon = payload.icon;
  return icon ? notificationIconMap[icon] : undefined;
};
